'use client';
import { RulesSheet } from '@/components/RulesSheet';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import translations from './AchievementRulesSheet.translations';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function AchievementRulesSheet({ isOpen, onClose }: Props) {
  const { t } = useLocalTranslation(translations);
  return (
    <RulesSheet
      isOpen={isOpen}
      onClose={onClose}
      title={t('title')}
      variant="plain"
      gapClassName="gap-5"
      intro={<p className="text-[13px] leading-relaxed text-label-secondary">{t('intro')}</p>}
      footer={
        <div className="rounded-2xl bg-fill-tertiary/60 px-4 py-3 text-[13px] leading-snug text-label-secondary">
          {t('footer')}
        </div>
      }
      rows={[
        { icon: <GiftGlyph />, tint: 'amber', title: t('rule1Title'), body: t('rule1Body') },
        { icon: <ShieldGlyph />, tint: 'sky', title: t('rule2Title'), body: t('rule2Body') },
        { icon: <HourglassGlyph />, tint: 'violet', title: t('rule3Title'), body: t('rule3Body') },
        { icon: <DepositGlyph />, tint: 'emerald', title: t('rule4Title'), body: t('rule4Body') },
      ]}
    />
  );
}

const S = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };

function GiftGlyph() {
  return (
    <svg {...S} aria-hidden>
      <rect x="3" y="8" width="18" height="4" rx="1" />
      <path d="M12 8v13M5 12v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7" />
      <path d="M12 8S10.5 4 8.5 4 5.5 6 7 8h5zM12 8s1.5-4 3.5-4S18.5 6 17 8h-5z" />
    </svg>
  );
}

function ShieldGlyph() {
  return (
    <svg {...S} aria-hidden>
      <path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6l7-3z" />
      <path d="M9.5 11.5h5M9.5 14h5" />
    </svg>
  );
}

function HourglassGlyph() {
  return (
    <svg {...S} aria-hidden>
      <path d="M6 3h12M6 21h12" />
      <path d="M7 3c0 5 4 6 5 9 1-3 5-4 5-9M7 21c0-5 4-6 5-9 1 3 5 4 5 9" />
    </svg>
  );
}

function DepositGlyph() {
  return (
    <svg {...S} aria-hidden>
      <path d="M12 3v10m0 0l-3.5-3.5M12 13l3.5-3.5" />
      <path d="M5 16v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3" />
    </svg>
  );
}
